module.exports = __webpack_public_path__ + "img/third-bg-container.186b7d94.png";